import { useEffect } from "react";
import { lightMarroon, darkRed } from "../../config/ColorObj";
import TypographyCompo from "../Comman/TypographyCompo";
import "./SubscriptionExpiryMarquee.css";

export default function SubscriptionExpiryMarquee({
    message = "⚠️ Your subscription will expire soon. Please renew to avoid interruption.",
    position, // "top" or "bottom"
}) {
    useEffect(() => {
        const storedData = JSON.parse(localStorage.getItem("marueeData"));
        const bgColor = storedData?.color3 || lightMarroon;
        const textColor = storedData?.stageIndex == 5 ? storedData?.color2 : darkRed;

        document.documentElement.style.setProperty("--marquee-bg", bgColor);
        document.documentElement.style.setProperty("--marquee-text", textColor);
    }, []);

    return (
        <div className={`marquee-container ${position}`}>
            <div className="marquee-track">
                <TypographyCompo className="marquee-text">{message}</TypographyCompo>
                <TypographyCompo className="marquee-text">{message}</TypographyCompo>
                <TypographyCompo className="marquee-text">{message}</TypographyCompo>
            </div>
        </div>
    );
}
